<div class="photo-preview-container">

  <img alt="" #img />

  <div class="buttons">
    <mat-icon (click)="downloadFile()">cloud_download</mat-icon>
    <mat-icon (click)="close()">close</mat-icon>
    <!-- <div (click)="downloadFile()">cloud_download</div> -->
    <!-- <div (click)="close()">close</div> -->
  </div>

</div>
